import { useStaticQuery, graphql } from "gatsby"

export  const useStrapiLatestWebinarsSeriesData = () => {
    const { allStrapiSerie } = useStaticQuery(graphql`
        query {
            allStrapiSerie(
                filter: {title: {regex: "/Cannabis Webinar Series/"}}
              ) {
                nodes {
                  title
                  slug
                  thumbnail {
                    alternativeText
                    localFile {
                      childImageSharp {
                        gatsbyImageData
                      }
                    }
                  }
                }
              }
          }
      `)
    return { allStrapiSerie }
}